import { render, staticRenderFns } from "./WarningSpirit.vue?vue&type=template&id=e06aad62&scoped=true&"
import script from "./WarningSpirit.vue?vue&type=script&lang=js&"
export * from "./WarningSpirit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06aad62",
  null
  
)

export default component.exports